import {
  GoogleAnalyticsEventsType,
  PRODUCT_REGISTRATION_SUCCESS_EVENT,
  utmParameters
} from '@nw/shared/config';

import { getFrontEndFormPathId, getQueryParam } from '../MiscellaneousUtils';

declare global {
  interface Window {
    analytics: any;
    mixpanel: any;
    dataLayer: any;
  }
}

export const integrationConfig = {
  integrations: {
    All: true,
    WebEngage: true
  }
};

export function sendLastTouchUtmParametersToMixpanel() {
  let kw = '';
  const params: Record<string, string> = {};

  for (let index = 0; index < utmParameters.length; ++index) {
    kw = getQueryParam(document.URL, utmParameters[index]);
    params[utmParameters[index]] = kw;
  }

  try {
    window.analytics &&
      window.analytics.ready(function () {
        const { mixpanel } = window;
        if (mixpanel) {
          mixpanel.register(params);
          mixpanel.people.set(params);
        }
      });
  } catch (e) {
    // console.log('e', e)
  }
}

const identify = (
  userId: string,
  properties = {},
  extraIntegrationConfig = integrationConfig
) => {
  if (window.analytics)
    window.analytics.identify(userId, properties, {
      ...extraIntegrationConfig
    });
};

const track = (
  title: string,
  properties = {},
  extraIntegrationConfig = {},
  shouldSendLastTouchEventToMixpanel = false
) => {
  if (shouldSendLastTouchEventToMixpanel) {
    sendLastTouchUtmParametersToMixpanel();
  }
  if (window.analytics)
    if (Object.keys(extraIntegrationConfig).length > 0) {
      window.analytics.track(title, properties, {
        integrations: {
          ...extraIntegrationConfig
        }
      });
    } else {
      window.analytics.track(title, properties, {
        ...integrationConfig
      });
    }
};

const reset = () => {
  if (window.analytics) window.analytics.reset();
};

export const segment = { identify, track, reset };

export const getSegmentEventIntegrationConfig = (
  trackEvent: any,
  extraIntegrationConfig = {}
) => {
  let segmentIntegrations = {};
  const segmentEventIntegrationConfig =
    trackEvent.segmentEventIntegrationConfig ?? {};

  if (Object.keys(segmentEventIntegrationConfig).length > 0) {
    segmentIntegrations = segmentEventIntegrationConfig;
  } else if (Object.keys(extraIntegrationConfig).length > 0) {
    segmentIntegrations = extraIntegrationConfig;
  } else {
    segmentIntegrations = integrationConfig.integrations;
  }

  return segmentIntegrations;
};

export const paymentSuccessAnalytics = (
  program: string,
  orderId: string,
  product: string,
  eventName = PRODUCT_REGISTRATION_SUCCESS_EVENT
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    program,
    orderId,
    quantity: 1,
    product,
    frontend_product_path_id: getFrontEndFormPathId()
  });
};

export function paymentInitiationAnalytics(
  eventName: string,
  program: string,
  product: string
) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    purchased_program: program,
    purchased_product: product
  });
}

export const sendGAEventToDataLayer = (
  gaEventProperties: Record<string, string | boolean | number>
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(gaEventProperties);
};

export const sendConfigGAEventToDataLayer = (
  googleAnalyticsEvents: GoogleAnalyticsEventsType,
  eventName: string,
  values: Record<string, any>
) => {
  const eventProperties = googleAnalyticsEvents[eventName];
  if (eventProperties) {
    const {
      frontend_product_path_id: frontendProductPathId,
      frontend_form_path_id: frontendFormPathId,
      event,
      ...rest
    } = eventProperties.event_properties;
    window.dataLayer = window.dataLayer || [];
    const gaEvent: Record<string, any> = {
      event: event
    };
    if (frontendFormPathId) {
      gaEvent['frontend_form_path_id'] = getFrontEndFormPathId();
    }
    if (frontendProductPathId) {
      gaEvent['frontend_product_path_id'] = getFrontEndFormPathId();
    }

    Object.keys(rest).forEach((key) => {
      gaEvent[key] = eval(rest[key]);
    });

    window.dataLayer.push(gaEvent);
  }
};

export function sendLoginFlowEventToDataLayer(
  eventName: string,
  formId?: string
) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    form_id: formId,
    frontend_form_path_id: getFrontEndFormPathId()
  });
}

export function sendPublicFormAnalyticsToDataLayer(eventName) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName
  });
}

export function formSubmissionAnalytics(eventObject) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventObject);
}

export function formVisitedAnalytics(eventObject) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventObject);
}
